module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.errors.length > 0) ? _c('div', {
    staticClass: "help is-danger"
  }, [_c('ul', _vm._l((_vm.errors), function(e) {
    return _c('li', {
      key: e
    }, [_vm._v("\n      " + _vm._s(e) + "\n    ")])
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4b84f791"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormErrors.vue
// module id = 1027
// module chunks = 0